import Layout from '@/layout'

export default {
  path: '/shop',
  component: Layout,
  redirect: '/shop/info',
  name: 'shop',
  meta: {
    title: '店铺管理',
    role: 1516,
    icon: 'shop'
  },
  children: [
    {
      path: 'info',
      component: () => import('@/pages/shop/info'),
      name: 'shopInfo',
      meta: { title: '店铺信息', role: 1517 }
    },
    {
      path: 'user',
      component: () => import('@/pages/shop/userList'),
      name: 'UserList',
      meta: { title: '子账号管理', role: 1608 }
    },
    {
      path: 'customerService',
      component: () => import('@/pages/shop/customer-service'),
      name: 'customerService',
      meta: { title: '客服管理', role: 1559 }
    },
    {
      path: 'freight/templete/list',
      component: () => import('@/pages/shop/freightTempleteList'),
      name: 'freightTempleteList',
      meta: { title: '运费模版', role: 1619 }
    },
    {
      path: 'freight/templete/detail',
      component: () => import('@/pages/shop/freightTempleteDetail'),
      name: 'freightTempleteDetail',
      meta: { title: '运费模版详情', role: 1619 },
      hidden: true
    },
    {
      path: 'member/equity/list',
      component: () => import('@/pages/shop/memberEquityList'),
      name: 'memberEquityList',
      hidden: true,
      meta: { title: '会员权益', role: 2720 }
    }
  ]
}
